import { render, staticRenderFns } from "./PatientRelationInsSelect.vue?vue&type=template&id=4fb9dab2&"
import script from "./PatientRelationInsSelect.vue?vue&type=script&lang=ts&"
export * from "./PatientRelationInsSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports